import { Country, GetMeetingRequestsByCompanyCountryQuery, GetMeetingRequestsByCompanyCountryQueryVariables } from './../../../types'
import { ApolloError, useQuery } from '@apollo/client'
import { GET_MEETING_REQUESTS_BY_COMPANY_COUNTRY } from '../MeetingRequestQueries'

export const useMeetingRequestByCompanyCountry = (
  companyId: string,
  country: Country,
): {
  data: GetMeetingRequestsByCompanyCountryQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<GetMeetingRequestsByCompanyCountryQuery, GetMeetingRequestsByCompanyCountryQueryVariables>(
    GET_MEETING_REQUESTS_BY_COMPANY_COUNTRY,
    {
      variables: {
        companyId: companyId,
        country: country,
      },
    },
  )

  return { data, error, loading }
}
